import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
} from "@mui/material";
import PdfGeneratorDialog from "../utils/GeneratePDF";
import { useNavigate } from "react-router-dom";
import styles from "../css/Home.module.css";

export default function Home() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const userRol = user?.id_rol;

  const [openComment, setOpenComment] = useState(false);
  const [formData, setFormData] = useState({
    year: "",
    month: "",
    department: "",
    municipality: "",
    question: "",
    comment: "",
  });

  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [commentExists, setCommentExists] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const [userLocation, setUserLocation] = useState(null);
  const [lock, setLock] = useState({ department: false, municipality: false });



const preguntas = [
    { id: 1, texto: "1. ¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?" },
    { id: 2, texto: "2. ¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?" },
    { id: 3, texto: "3. ¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?" },
    { id: 4, texto: "4. ¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?" },
    { id: 5, texto: "5. ¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA? " },
    { id: 6, texto: "6. ¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?" },
    { id: 7, texto: "7. ¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?" },
    { id: 8, texto: "8. ¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?" },
    { id: 9, texto: "9. ¿En el Plan municipal de intervenciones se tienen incluidas intervenciones y recursos del Gobierno municipal?" },
    { id: 10, texto: "10. ¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?" },
    { id: 11, texto: "11. ¿En su municipio se han priorizado comunidades para intensificar las acciones?" },
    { id: 12, texto: "12. ¿Cuántas comunidades han sido priorizadas en su municipio?" },
    { id: 13, texto: "13. ¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?" },
    { id: 14, texto: "14. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?" },
    { id: 15, texto: "15. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? " },
    { id: 16, texto: "16. ¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? " },
    { id: 17, texto: "17. ¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?" },
    { id: 18, texto: "18. ¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?" },
    { id: 19, texto: "19. ¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?" },
    { id: 20, texto: "20. ¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?" },
    { id: 21, texto: "21. ¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?" },
    { id: 22, texto: "22. ¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?" },
    { id: 23, texto: "23. ¿En el municipio se cuenta con el registro de familias que han sido beneficiadas con programas sociales o institucionales?" },
    { id: 24, texto: "24. ¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?" },
    { id: 25, texto: "25. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?" },
    { id: 26, texto: "26. ¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?" },
    { id: 27, texto: "27. ¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?" },
    { id: 28, texto: "28. ¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?" },
    { id: 29, texto: "29. ¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?" },
  ];


  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirmSubmit = () => {
    setOpenConfirm(false);
    handleSubmit(); 
  };


const handleOpenComment = async () => {
  setFormData({ 
    department: "", 
    municipality: "", 
    year: "", 
    month: "", 
    question: "", 
    comment: "" 
  });

  setOpenComment(true);
  await fetchDepartments();

  setLock({ department: false, municipality: false });

  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`/user-location?username=${user.username}`);
    const location = await res.json();
    setUserLocation(location);

    if (location.type === "central") {
      return;
    }

    if (location.type === "department") {
      setFormData(prev => ({
        ...prev,
        department: location.departamentoId,
        municipality: "ALL"
      }));

      setLock({ department: true, municipality: true });

      const resM = await fetch(
        `/comentarios/municipios-disponibles/${location.departamentoId}`
      );
      const municipios = await resM.json();

      setMunicipalities([
        { municipioId: "ALL", municipioName: "Comentario Departamental" },
        ...municipios
      ]);

      return;
    }

    if (location.type === "municipality") {
      setFormData(prev => ({
        ...prev,
        department: location.departamentoId,
        municipality: location.municipioId
      }));

      setLock({ department: true, municipality: true });

      const resM = await fetch(
        `/comentarios/municipios-disponibles/${location.departamentoId}`
      );
      const municipios = await resM.json();

      setMunicipalities(municipios);
    }

  } catch (err) {
    console.error("Error obteniendo user-location:", err);
  }
};

  const handleCloseComment = () => setOpenComment(false);

  const fetchDepartments = async () => {
    const res = await fetch(`/comentarios/departamentos-disponibles`);
    const data = await res.json();
    
    const user = JSON.parse(localStorage.getItem("user"));
    const resLocation = await fetch(`/user-location?username=${user.username}`);
    const location = await resLocation.json();
    
    const departmentsWithAll = location.type === "central" 
      ? [{ departamentoId: "todos", departamentoName: "Todos los departamentos" }, ...data]
      : data;
    
    setDepartments(departmentsWithAll);
  };

  useEffect(() => {
    if (formData.department) {
      (async () => {
        const res = await fetch(`/comentarios/municipios-disponibles/${formData.department}`);
        const data = await res.json();
        setMunicipalities(data);
        setYears([]);
        setMonths([]);
      })();
    }
  }, [formData.department]);

  useEffect(() => {
    const loadYears = async () => {
      if (!formData.department) return;

      let url = "";

      if (formData.department === "todos") {
        url = `/comentarios/anios-disponibles?departamentoId=todos`;
      } else if (!formData.municipality || formData.municipality === "ALL") {
        url = `/comentarios/anios-disponibles?departamentoId=${formData.department}`;
      } else {
        url = `/comentarios/anios-disponibles?municipioId=${formData.municipality}`;
      }

      const res = await fetch(url);
      const data = await res.json();
      setYears(data);
      setMonths([]);
    };

    loadYears();
  }, [formData.municipality, formData.department]);


  useEffect(() => {
    const loadMonths = async () => {
      if (!formData.year || !formData.department) return;

      let url = "";

      if (formData.department === "todos") {
        url = `/comentarios/meses-disponibles?departamentoId=todos&anio=${formData.year}`;
      } else if (!formData.municipality || formData.municipality === "ALL") {
        url = `/comentarios/meses-disponibles?departamentoId=${formData.department}&anio=${formData.year}`;
      } else {
        url = `/comentarios/meses-disponibles?municipioId=${formData.municipality}&anio=${formData.year}`;
      }

      const res = await fetch(url);
      const data = await res.json();
      setMonths(data);
    };

    loadMonths();
  }, [formData.year, formData.municipality, formData.department]);


  useEffect(() => {
    if (
      formData.department &&
      formData.year &&
      formData.month &&
      formData.question
    ) {
      (async () => {
        const municipioParam =
          formData.municipality === "ALL" || !formData.municipality
            ? ""
            : `&municipioId=${formData.municipality}`;

        const departamentoId = formData.department === "todos" ? "todos" : formData.department;

        const url =
          `${process.env.REACT_APP_API_URL}/comentarios/existente?usuarioId=${user.id}` +
          `&departamentoId=${departamentoId}` +
          `${municipioParam}` +
          `&preguntaNo=${formData.question}` +
          `&mes=${formData.month}` +
          `&anio=${formData.year}`;

        try {
          const res = await fetch(url);
          const data = await res.json();

          if (data.existe) {
            setFormData(prev => ({ ...prev, comment: data.comentario }));
            setCommentExists(true);
          } else {
            setFormData(prev => ({ ...prev, comment: "" }));
            setCommentExists(false);
          }
        } catch (err) {
          console.error("Error al verificar comentario existente:", err);
        }
      })();
    }
}, [formData.department, formData.municipality, formData.year, formData.month, formData.question]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.year || !formData.month || !formData.department || !formData.comment) {
      setSnackbar({
        open: true,
        message: "Por favor completa todos los campos.",
        severity: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      let municipioIdValue = null;
      let departamentoIdValue = formData.department;

      if (formData.department === "todos") {
        municipioIdValue = null;
        departamentoIdValue = "todos";
      } else if (formData.municipality === "ALL") {
        municipioIdValue = null;
      } else {
        municipioIdValue = formData.municipality;
      }

      const res = await fetch(`/comentarios`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          usuarioId: user.id,
          departamentoId: departamentoIdValue,
          municipioId: municipioIdValue,
          preguntaNo: Number(formData.question),
          comentario: formData.comment,
          mes: formData.month,
          anio: formData.year,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSnackbar({
          open: true,
          message: data.updated
            ? "Comentario actualizado correctamente"
            : "Comentario agregado correctamente",
          severity: "success",
        });
        handleCloseComment();
      } else {
        setSnackbar({
          open: true,
          message: "Error al guardar comentario",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Error al enviar comentario:", err);
      setSnackbar({
        open: true,
        message: "Error al conectar con el servidor",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  let cards = [
    {
      title: "Ver Tabla",
      description: "Consulta y análisis de datos de desnutrición aguda por territorio.",
      image: "images/table.png",
      path: "/tabla",
    },
    {
      title: "Ver Graficas",
      description: "Visualización gráfica de indicadores.",
      image: "images/3d_bar_chart.png",
      path: "/graficas",
    },
    {
      title: "Impresion de PDF",
      description: "Generación de reportes del protocolo interinstitucional",
      image: "images/chart_curve.png",
      action: () => setOpenPdf(true),
    },
    {
      title: "Editar Comentario",
      description: "Agregar o editar un comentario a un reporte PDF",
      image: "images/chart_curve.png",
      action: handleOpenComment,
    },
    {
      title: "Descargas",
      description: "Descargar Protocolo",
      image: "images/attachment.png",
      action: () => {
      window.open(
        "https://portal.siinsan.gob.gt/protocolos_abordaje_municipal/",
        "_blank",
        "noopener,noreferrer"
        );
    },
    },
  ];

 if (userRol === 3 && userRol === 5 && userRol === 7) {
    cards = cards.filter(card => card.title !== "Ver Tabla");
    cards = cards.filter(card => card.title !== "Ver Graficas");
    cards = cards.filter(card => card.title !== "Impresion de PDF");
    cards = cards.filter(card => card.title !== "Editar Comentario");
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.cardContainer}>
        {cards.map((card, idx) => (
          <Paper
            key={idx}
            elevation={3}
            className={styles.card}
            onClick={() => {
              if (card.path) navigate(card.path);
              if (card.action) card.action();
            }}
          >
            <Box className={styles.cardHeader}>
              <img src={card.image} alt={card.title} className={styles.cardIcon} />
              <Typography variant="h6" className={styles.cardTitle}>
                {card.title}
              </Typography>
            </Box>
            <Typography variant="body2" className={styles.cardText}>
              {card.description}
            </Typography>
          </Paper>
        ))}
      </Box>

      <PdfGeneratorDialog open={openPdf} onClose={() => setOpenPdf(false)} />
      <Dialog open={openComment} onClose={handleCloseComment} maxWidth="sm" fullWidth>
        ...
      </Dialog>

      <Dialog open={openComment} onClose={handleCloseComment} maxWidth="sm" fullWidth>
        <DialogTitle>Agregar / Editar Comentario</DialogTitle>
        <DialogContent>

        <FormControl fullWidth margin="normal" disabled={lock.department}>
          <InputLabel>Departamento</InputLabel>
          <Select
            name="department"
            value={formData.department}
            onChange={handleChange}
          >
            {departments.map((d) => (
              <MenuItem key={d.departamentoId} value={d.departamentoId}>
                {d.departamentoName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <FormControl 
          fullWidth 
          margin="normal" 
          disabled={!formData.department || formData.department === "todos" || lock.municipality}
        >
          <InputLabel>Municipio</InputLabel>
          <Select
            name="municipality"
            value={formData.municipality}
            onChange={handleChange}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            {municipalities.map((m) => (
              <MenuItem key={m.municipioId} value={m.municipioId}>
                {m.municipioName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <FormControl fullWidth margin="normal" disabled={!formData.department}>
          <InputLabel>Año</InputLabel>
          <Select
            name="year"
            value={formData.year}
            onChange={handleChange}
          >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal" disabled={!formData.year}>
          <InputLabel>Mes</InputLabel>
          <Select
            name="month"
            value={formData.month}
            onChange={handleChange}
          >
            {months.map((m) => (
              <MenuItem key={m} value={m}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal" disabled={!formData.month}>
          <InputLabel>Pregunta</InputLabel>
          <Select
            name="question"
            value={formData.question}
            onChange={handleChange}
            MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          >
            {preguntas.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.texto}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          name="comment"
          label="Comentario"
          multiline
          rows={4}
          fullWidth
          margin="normal"
          value={formData.comment}
          onChange={handleChange}
          inputProps={{ maxLength: 250 }}
          helperText={`${formData.comment.length}/250`}
        />

      </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseComment}>Cancelar</Button>
          <Button 
            variant="contained" 
            onClick={() => setOpenConfirm(true)} 
            disabled={loading}
          >
            {loading ? "Guardando..." : commentExists ? "Actualizar" : "Enviar"}
          </Button>

        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
      >
        <DialogTitle>
          Confirmación
        </DialogTitle>
              
        <DialogContent>
          <Typography>
            ¿Está seguro que desea {commentExists ? "actualizar" : "agregar"} este comentario?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmSubmit}>
            Sí, continuar
          </Button>
        </DialogActions>
      </Dialog>


      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
